<script setup>
import { computed } from 'vue'
import { useAuth } from '@/Hooks/Company/useAuth.js'
import { Button } from '@aryeo/runway'
import { pluralize } from '@/Utils/StringFormatter.js'
import { router } from '@inertiajs/vue3'
import { Alert } from '@aryeo/runway'

const { authCompanyUser, passwordExpirationReminderDays } = useAuth()

const showBanner = computed(
  () =>
    authCompanyUser.value?.password_expiration_days !== null &&
    authCompanyUser.value?.password_expiration_days <= passwordExpirationReminderDays.value
)
</script>

<template>
  <div
    v-if="showBanner"
    class="flex gap-4 max-sm:flex-col items-center justify-between text-center bg-warning-lightest text-warning-darkest px-3 py-2 font-[sans-serif]"
  >
    <div class="flex items-center justify-between gap-4 w-full">
      <Alert
        type="warning"
        :description="`Your password will expire in ${authCompanyUser.password_expiration_days} ${pluralize(authCompanyUser.password_expiration_days, 'day', 'days')}.`"
      />

      <Button
        class="border-warning-dark [&>span]:!text-warning-darkest [&_svg]:!text-warning-darkest"
        color="warning"
        isSecondary
        isSmall
        text="Change Password"
        @click="router.visit(route('web.company.auth-company-user.show'))"
      />
    </div>
  </div>
</template>
